/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const IncidentRecordFileInfoDto = zod.object({
  "id": zod.string().uuid().optional(),
  "blobId": zod.string().optional(),
  "fileName": zod.string().optional(),
  "fileType": zod.string().optional(),
  "fileSize": zod.number().optional(),
  "path": zod.string().optional(),
  "url": zod.string().optional(),
  "isSignedDocument": zod.boolean().optional(),
  "fileFieldTypeId": zod.number().optional(),
  "createDate": zod.coerce.date().optional(),
  "createdBy": zod.string().optional(),
  "isConfirmed": zod.boolean().optional(),
  "confirmedDate": zod.coerce.date().optional(),
  "confirmedBy": zod.string().optional(),
  "isAcknowledged": zod.boolean().optional(),
  "sourceUnsignedId": zod.string().uuid().optional()
});

export type IncidentRecordFileInfoDto = zod.input<typeof IncidentRecordFileInfoDto>;
export type IncidentRecordFileInfoDtoOutput = zod.output<typeof IncidentRecordFileInfoDto>;
